<template>
  <ElementVotes
    :votes="votesAggregate"
    :current-user-vote-type="currentUserVoteType"
    @voteClick="elementVoteClick"
  />
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { types as analysisVotesTypes } from '../../../store/analysisVotes';
import ElementVotes from '../ElementVotes';
import { getValueFromVoteType, getVoteType } from './votesHelper';

export default {
  name: 'AnalysisElementVote',
  components: {
    ElementVotes,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    analysisId: {
      type: String,
      required: true,
    },
    userAnalysisId: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getUserAnalysisVotes: analysisVotesTypes.getters.userAnalysisVotes,
    }),
    votes() {
      return this.getUserAnalysisVotes({
        analysisId: this.analysisId,
        userAnalysisId: this.userAnalysisId,
      });
    },
    votesAggregate() {
      return {
        [getVoteType(1)]: this.getElementVotes(this.item.id, 1),
        [getVoteType(2)]: this.getElementVotes(this.item.id, 2),
        [getVoteType(3)]: this.getElementVotes(this.item.id, 3),
      };
    },
    currentUserVoteType() {
      if (this.votes) {
        const userVote = this.votes.find(vote => vote.id === this.userId);
        if (userVote !== undefined) {
          return getVoteType(userVote.votes[this.item.id]);
        }
      }
      return undefined;
    },
  },
  methods: {
    ...mapActions({
      updateUserAnalysisVote: analysisVotesTypes.actions.updateUserAnalysisVote,
      fetchUserAnalysisVotes: analysisVotesTypes.actions.fetchUserAnalysisVotes,
    }),
    getElementVotes(elementId, voteType) {
      // eslint-disable-next-line
      if (!this.votes) return null;

      const nbVotes = this.votes.reduce((count, votes) => {
        const elemVoteValue = votes.votes[elementId];
        if (elemVoteValue) {
          return elemVoteValue === voteType ? count + 1 : count;
        }
        return count;
      },
      0);
      return nbVotes;
    },
    elementVoteClick(voteType) {
      this.updateUserAnalysisVote({
        analysisId: this.analysisId,
        userAnalysisId: this.userAnalysisId,
        elementId: this.item.id,
        userId: this.userId,
        voteType: getValueFromVoteType(voteType),
      });
    },
  },
  created() {
    this.fetchUserAnalysisVotes({ analysisId: this.analysisId, userAnalysisId: this.userAnalysisId });
  },
};
</script>
